import { Stack } from 'expo-router'

export default function RegningerLayout() {
  return <Stack screenOptions={{ headerShown: false }} />
}
